import 'css-chunksrc/client/scenes/folderCreation/form/folderSelection/folder/styles.scss';export default {
  "name": "_name_12uy3_1",
  "selected": "_selected_12uy3_10"
};